import { TreasuryView } from "./treasury-view"

const DEBANK_TREASURY_BUNDLE_URL = "https://debank.com/bundles/218882/portfolio"

export const TreasuryComposite = () => {
  return <TreasuryView debankBundleUrl={DEBANK_TREASURY_BUNDLE_URL} />
}
